import { FunctionComponent } from "react";
import { Container } from "../../../components/formulario/styled";
import HeaderAssociarMembroPg from "./header";
import TabelasMembrosPg from "./tabela";


interface ContainerAssociarMembroPgProps {

}

const ContainerAssociarMembroPg: FunctionComponent<ContainerAssociarMembroPgProps> = () => {
  return (<>
    <Container>
      <HeaderAssociarMembroPg />
      <TabelasMembrosPg />
    </Container>
  </>);
}

export default ContainerAssociarMembroPg;
